<div class="product-elements">
  @if (showOfferDataInputs) {
    <div class="details-card mat-elevation-z1 data-for-offer">
      <div class="details-card-header">{{'CONFIGURATOR|Podstawowe dane' | translate}}</div>
      <div class="details-card-body">
        <ul>
          <li>
            <span class="details-label">{{'INTERFACE|Nazwa' | translate}}</span>
            <mat-form-field style="width: 85%;" appearance="outline">
              <input
                matInput
                (blur)='onNameChange($event.target.value)'
                [value]='customConstructionName'
                type="text"
                min="1">
              </mat-form-field>
            </li>
            @if (config().preset === 'b2b' && !config().IccConfig.Configurators.configurationQuantityWithButtonsAndCustomName) {
              <li>
                <span class="details-label">{{'CONFIGURATOR|Ilość' | translate}}</span>
                <mat-form-field>
                  <input matInput (blur)='onQuantityChange($event.target.value)' type="number" min="1" [value]='quantity'>
                </mat-form-field>
              </li>
            }
            @if (config().IccConfig.Configurators.configurationQuantityWithButtonsAndCustomName) {
              <li>
                <span class="details-label">{{'CONFIGURATOR|Ilość' | translate}}</span>
                <div class="details-quantity">
                  <button class="details-quantity__btn"
                    type="button"
                    mat-mini-fab
                    color=""
                  (click)="increaseQuantity()">+</button>
                  <mat-form-field class="details-quantity__field" appearance="outline" subscriptSizing="dynamic">
                    <input class="details-quantity__input"
                      type="text"
                      maxlength="3"
                      matInput
                      iccDigitsOnly
                      [allowLeadingZeroes]="false"
                      (blur)='onQuantityChange($event.target.value)'
                      [value]='quantity'>
                  </mat-form-field>
                  <button class="details-quantity__btn"
                    type="button"
                    mat-mini-fab
                    color=""
                  (click)="decreaseQuantity()">-</button>
                </div>
              </li>
            }
              @if (!hiddenPrice) {
                <li>
                  <span class="details-label">{{'CONFIGURATOR|Cena (netto)' | translate}}</span> <span class="value">{{ price / quantity | currency:currency:null:false }} </span>
                </li>
              }
              @if (!hiddenPrice) {
                <li>
                  <span class="details-label">{{'CONFIGURATOR|Wartość (netto)' | translate}}</span> <span class="value">{{ price | currency:currency:null:false }}</span>
                </li>
              }
            </ul>
          </div>
        </div>
      }
      @if (componentsAvailable) {
        <div class="details-card mat-elevation-z1 data-for-offer">
          <div class="details-card-header">{{'DOOR|Zamawianie elementów składowych' | translate}}</div>
          <div class="details-card-body">
            <p class="section-description">{{'DOOR|Wybierz które elementy drzwi chcesz zamówić osobno. Gdy wybierzesz "Komplet drzwiowy", wszystkie pozostałe opcje będą niedostępne.' | translate}}</p>
            <ul>
              <li>
                <mat-checkbox
                  [(ngModel)]="components.fullDoor"
                  (change)="onComponentChange('fullDoor', $event.checked)">
                </mat-checkbox>
                <span class="details-label">{{'DOOR|Komplet drzwiowy' | translate}}</span>
              </li>
            </ul>
            <ul [class.disabled]="components.fullDoor">
              @for (component of componentsList; track component) {
                <li
                  [style.display]="isComponentAvailable(component.path) ? 'block' : 'none'">
                  <mat-checkbox
                    [ngModel]="getComponentValue(component.path)"
                    [disabled]="isComponentDisabled(component.path)"
                    [matTooltip]="isComponentDisabled(component.path) ? ('DOOR|Musi być zaznaczony przynajmniej jeden element' | translate) : ''"
                    (change)="onComponentChange(component.path, $event.checked)">
                  </mat-checkbox>
                  <span class="details-label">{{component.labelKey | translate}}</span>
                </li>
              }
            </ul>
          </div>
        </div>
      }
      @for (parent of detailsTree.$$children; track parent) {
        <div class="details-card mat-elevation-z1">
          <div class="details-card-header">{{parent.name}}</div>
          <div class="details-card-body">
            @if (parent.$$children && parent.$$children.length > 0) {
              <ul>
                @for (el of parent.$$children; track el) {
                  <li>
                    @if (el.name) {
                      <span class="details-label">{{el.name}}:</span>
                      } @if (el.value) {
                      <span class="value">{{el.value}}</span>
                    }
                    @if (el.$$children && el.$$children.length > 0) {
                      <ul>
                        @for (el2 of el.$$children; track el2) {
                          <li>
                            @if (el2.name) {
                              <span class="details-label">{{el2.name}}:</span>
                              } @if (el2.value) {
                              <span class="value">{{el2.value}}</span>
                            }
                            @if (el2.$$children && el2.$$children.length > 0) {
                              <ul>
                                @for (el3 of el2.$$children; track el3) {
                                  <li>
                                    @if (el3.name) {
                                      <span class="details-label">{{el3.name}}:</span>
                                      } @if (el3.value) {
                                      <span class="value">{{el3.value}}</span>
                                    }
                                    @if (el3.$$children && el3.$$children.length > 0) {
                                      <ul>
                                        @for (el4 of el3.$$children; track el4) {
                                          <li>
                                            @if (el4.name) {
                                              <span class="details-label">{{el4.name}}:</span>
                                              } @if (el4.value) {
                                              <span class="value">{{el4.value}}</span>
                                            }
                                          </li>
                                        }
                                      </ul>
                                    }
                                  </li>
                                }
                              </ul>
                            }
                          </li>
                        }
                      </ul>
                    }
                  </li>
                }
              </ul>
            }
            @if (!parent.$$children?.length && parent.value) {
              <span class="value">{{parent.value}}</span>
            }
          </div>
        </div>
      }
    </div>
